import { render, staticRenderFns } from "./rillpayconfig.vue?vue&type=template&id=64923115&"
import script from "./rillpayconfig.vue?vue&type=script&lang=js&"
export * from "./rillpayconfig.vue?vue&type=script&lang=js&"
import style0 from "./rillpayconfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports